(() => {
  if (window.hdMobileNavigation) {
    window.hdMobileNavigation.init();
    return;
  }
  const instances = new Map();
  const mobile = window.matchMedia('(max-width: 798px)');
  function setup(dialog) {
    if (instances.has(dialog) || typeof dialog.showModal !== 'function') return;
    if (getComputedStyle(dialog).getPropertyValue('--hd-nav-ready').trim() !== '1') return;
    const section = dialog.closest('.shopify-section') || document;
    const header = section.querySelector('#mobile-header');
    const trigger = header && header.querySelector('[data-show-mobile-menu]');
    if (!trigger || !dialog.querySelector('[data-hd-nav-panel]')) return;
    const controller = new AbortController();
    const options = {signal: controller.signal};
    const scroller = dialog.querySelector('[data-hd-nav-scroll]');
    const panels = [...dialog.querySelectorAll('[data-hd-nav-panel]')];
    const root = dialog.dataset.hdNavRoot;
    const triggerAttributes = ['role', 'tabindex', 'aria-label', 'aria-controls', 'aria-expanded', 'aria-haspopup'];
    const savedAttributes = triggerAttributes.map(name => [name, trigger.getAttribute(name)]);
    let scrollX = 0, scrollY = 0, previousFocus = trigger, bodyStyles = null;
    function panel(id, focus) {
      const next = panels.find(el => el.id === id);
      if (!next) return;
      panels.forEach(el => { el.hidden = el !== next; });
      dialog.querySelectorAll('[data-hd-nav-open]').forEach(el => el.setAttribute('aria-expanded', String(el.dataset.hdNavOpen === id)));
      scroller.scrollTop = 0;
      if (focus) (next.querySelector('.hd-nav-title') || next.querySelector('button, a'))?.focus({preventScroll: true});
    }
    function restore() {
      if (!bodyStyles) return;
      const body = document.body;
      bodyStyles.forEach(([name, value, priority]) => {
        if (value) body.style.setProperty(name, value, priority);
        else body.style.removeProperty(name);
      });
      bodyStyles = null;
      trigger.setAttribute('aria-expanded', 'false');
      header.querySelector('.mobile-menu__toggle-icon')?.classList.remove('is-active');
      window.scrollTo({left: scrollX, top: scrollY, behavior: 'instant'});
      if (mobile.matches && previousFocus?.isConnected) previousFocus.focus({preventScroll: true});
    }
    function close() {
      if (dialog.open) dialog.close();
      restore();
    }
    function open() {
      if (!mobile.matches || dialog.open) return;
      scrollX = window.scrollX;
      scrollY = window.scrollY;
      previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
      if (previousFocus === document.body) previousFocus = trigger;
      panel(root, false);
      try { dialog.showModal(); } catch (_) { return; }
      const body = document.body;
      bodyStyles = ['position', 'top', 'left', 'width', 'overflow'].map(name => [name, body.style.getPropertyValue(name), body.style.getPropertyPriority(name)]);
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
      body.style.left = `-${scrollX}px`;
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      header.querySelector('.mobile-menu__toggle-icon')?.classList.add('is-active');
      dialog.querySelector('[data-hd-nav-close]').focus({preventScroll: true});
    }
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('tabindex', '0');
    trigger.setAttribute('aria-label', dialog.dataset.hdNavOpenLabel);
    trigger.setAttribute('aria-controls', dialog.id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'dialog');
    header.classList.add('hd-nav-enhanced');
    trigger.addEventListener('click', e => {
      if (!mobile.matches) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }, {capture: true, signal: controller.signal});
    trigger.addEventListener('keydown', e => {
      if (mobile.matches && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        e.stopPropagation();
        open();
      }
    }, options);
    dialog.addEventListener('click', e => {
      const target = e.target.closest('button');
      if (!target) return;
      if (target.hasAttribute('data-hd-nav-close')) close();
      else if (target.dataset.hdNavOpen) panel(target.dataset.hdNavOpen, true);
      else if (target.dataset.hdNavBack) {
        const oldPanel = panels.find(el => !el.hidden);
        panel(target.dataset.hdNavBack, false);
        const returnTrigger = [...dialog.querySelectorAll('[data-hd-nav-open]')].find(el => el.dataset.hdNavOpen === oldPanel?.id);
        returnTrigger?.focus({preventScroll: true});
      }
    }, options);
    dialog.addEventListener('cancel', e => { e.preventDefault(); close(); }, options);
    dialog.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last?.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first?.focus();
      }
    }, options);
    dialog.addEventListener('close', restore, options);
    mobile.addEventListener('change', () => { if (!mobile.matches) close(); }, options);
    instances.set(dialog, () => {
      close();
      controller.abort();
      header.classList.remove('hd-nav-enhanced');
      savedAttributes.forEach(([name, value]) => value === null ? trigger.removeAttribute(name) : trigger.setAttribute(name, value));
      instances.delete(dialog);
    });
  }
  function init() {
    instances.forEach((destroy, dialog) => { if (!dialog.isConnected) destroy(); });
    document.querySelectorAll('[data-hd-nav]').forEach(setup);
  }
  window.hdMobileNavigation = {init};
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', e => {
    instances.forEach((destroy, dialog) => { if (e.target.contains(dialog)) destroy(); });
  });
  window.addEventListener('load', init);
  window.addEventListener('pageshow', () => instances.forEach((_, dialog) => { if (dialog.open) dialog.close(); }));
  init();
})();
